__webpack_require__.p = "https://app.terraform.mind.creai.cloud/";